module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"itemsFound":"{count} found","placeholder":"Filter and choose"},"no":{"itemsFound":"{count} treff","placeholder":"Filtrer og velg"}}')
  delete Component.options._Ctor
}
